import React from 'react';
import Button from './Button';

/** Neutral placeholder for "nothing here yet". */
export const EmptyState = ({ icon, title, description, action }) => (
  <div className="ij-state">
    {icon && <div className="ij-state__icon">{icon}</div>}
    {title && <p className="ij-state__title">{title}</p>}
    {description && <p className="ij-state__body">{description}</p>}
    {action}
  </div>
);

/** Failure state with an optional retry. */
export const ErrorState = ({
  title = 'Something went wrong',
  description = 'We could not load this content. Please try again.',
  onRetry,
}) => (
  <div className="ij-state" role="alert">
    <div className="ij-state__icon" aria-hidden="true">
      <svg width="26" height="26" viewBox="0 0 24 24" fill="currentColor">
        <path d="M12 2 1 21h22L12 2zm1 14h-2v2h2v-2zm0-6h-2v5h2v-5z" />
      </svg>
    </div>
    <p className="ij-state__title">{title}</p>
    <p className="ij-state__body">{description}</p>
    {onRetry && (
      <Button variant="outline" size="sm" onClick={onRetry}>
        Try again
      </Button>
    )}
  </div>
);

/** Inline spinner for a section that is loading inside an existing page. */
export const InlineLoader = ({ label = 'Loading' }) => (
  <div className="ij-state" role="status" aria-live="polite">
    <span className="ij-spinner" aria-hidden="true" />
    <span className="ij-visually-hidden">{label}</span>
  </div>
);
